import { Textbox } from "components/Textbox/Textbox";
import { UnitDictionary } from "pages/InventoryAndSales/Inventory/BaseDefinitionAndSetting/Unit/components/UnitDictionary";
import React, { useEffect, useState } from "react";
import { RoundWithRoundingPlace } from "utils/helpers";

interface Props {
  mode: "view" | "edit";
  resetForm: any;
  setUserChanges: (e: any) => void;
  numberOfSalesUnit: number;
  priceList: any;
  priceListDetail: any[];

  rate: any;
  Constraint: any;
  detailPriceData: any;
  setRate: (e: any) => void;
  setPriceListDetail: (e: any) => void;
  updateQuantity: (e: any, list?: any, type?: any) => void;
  setDictionaryName: (e: any) => void;
  jobId?:string
}
const PriceFields: React.FC<Props> = ({
  mode,
  resetForm,
  setUserChanges,
  numberOfSalesUnit,
  priceList,
  priceListDetail,
jobId,
  rate,
  Constraint,
  detailPriceData,
  setRate,
  setPriceListDetail,
  updateQuantity,
  setDictionaryName,
}) => {
  const [qty, setQty] = useState({
    qty1: detailPriceData.Qty1,
    qty2: detailPriceData.Qty2,
  });

  const handleQuantityChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    qtyType: "Qty1" | "Qty2"
  ) => {
    const value = +e.target.value;
    if (
      (numberOfSalesUnit === (qtyType === "Qty1" ? 1 : 2) ||
        (!detailPriceData.IsAbsoluteUnitConversionRatio &&
          detailPriceData.IsAbsoluteUnitConversionRatio != null)) &&
      value >= +e.target.min &&
      (e.target.max ? value <= +e.target.max : true)
    ) {
      if (
        !detailPriceData.IsAbsoluteUnitConversionRatio &&
        detailPriceData.IsAbsoluteUnitConversionRatio != null
      ) {
        setRate(
          (qtyType === "Qty1" ? value : qty.qty1) /
            (qtyType === "Qty1" ? qty.qty2 : value)
        );
      }
      updateQuantity(
        value,
        [],
        !detailPriceData.IsAbsoluteUnitConversionRatio &&
          detailPriceData.IsAbsoluteUnitConversionRatio != null
          ? qtyType
          : null
      );
    }
  };


  useEffect(() => {
    setQty({ qty1: detailPriceData.Qty1, qty2: detailPriceData.Qty2 });
  }, [detailPriceData]);
  return (
    <>
      <div className="row">
        <div className="col-lg-3">
          <Textbox
            Change={setUserChanges}
            textboxName="Qty1"
            textboxType="number"
            labelText="Qty1"
            customClass={"arrow-none"}
            step={10 ** detailPriceData.Qty1RoundingPlace}
            readonly={
              numberOfSalesUnit != 1 &&
              detailPriceData.IsAbsoluteUnitConversionRatio &&
              detailPriceData.IsAbsoluteUnitConversionRatio != null
            }
            value={
              detailPriceData.Qty1
                ? detailPriceData.Qty1
                : detailPriceData.Qty1 == 0
                ? "0"
                : "1"
            }
            defaultValue={
              detailPriceData.Qty1
                ? detailPriceData.Qty1
                : detailPriceData.Qty1 == 0
                ? "0"
                : "1"
            }
  
            min={
              priceListDetail[0]?.QtyMainUnit
            }
            max={
              priceListDetail[0]?.Stock
            }
            resetForm={resetForm}
            mode={jobId?'view':mode}
            required={true}
            onChange={(e) => handleQuantityChange(e, "Qty1")}
          />
        </div>
        <div className="col-lg-3">
          <UnitDictionary
            returnObj
            Change={setUserChanges}
            value={detailPriceData.Unit1Id}
            label="Unit1"
            name="Unit1Id"
            required={false}
            mode="view"
            resetForm={resetForm}
            setUnitDictionary={(e) =>
              setDictionaryName((prev) => ({ ...prev, Unit1: e.Value }))
            }
          />
        </div>
        {/* <div className="col-lg-3 col-12">
          <Textbox
            Change={setUserChanges}
            textboxName={
              numberOfSalesUnit === 1 ? "SalesUnitPrice" : "Unit1Price"
            }
            textboxType="text"
            labelText="UnitPrice"
            value={
              detailPriceData[
                `${numberOfSalesUnit === 1 ? "SalesUnitPrice" : "UnitPrice"}`
              ]
            }

            defaultValue={
              detailPriceData[
                `${numberOfSalesUnit === 1 ? "SalesUnitPrice" : "UnitPrice"}`
              ]
            }
            resetForm={resetForm}
            mode={priceList.IsManual && mode !== "view" ? "create" : "view"}
            useGroupingPrice={true}
            onChange={(e) => handleUnitPriceChange(e, "Qty1")}
            required={false}
          />
        </div> */}
        {/* <div className="col-lg-3">
          {numberOfSalesUnit === 1 && (
            <Textbox
              Change={setUserChanges}
              textboxName="SubTotalPrice"
              textboxType="text"
              labelText="price"
              value={detailPriceData.SubTotalPrice}
              round={false}
              defaultValue={detailPriceData.SubTotalPrice}
              resetForm={resetForm}
              mode={priceList.IsManual && mode !== "view" ? "create" : "view"}
              useGroupingPrice={true}
              required={false}
            />
          )}
        </div> */}
      </div>

      {detailPriceData.Unit2Id && (
        <div className="row">
          <div className="col-lg-3">
            <Textbox
              Change={setUserChanges}
              textboxName="Qty2"
              textboxType="number"
              labelText="Qty2"
              customClass={"arrow-none"}
              step={10 ** detailPriceData.Qty2RoundingPlace}
              readonly={
                numberOfSalesUnit !== 2 &&
                detailPriceData.IsAbsoluteUnitConversionRatio &&
                detailPriceData.IsAbsoluteUnitConversionRatio != null
              }
              defaultValue={
                detailPriceData.Qty2
                  ? detailPriceData.Qty2
                  : detailPriceData.Qty2 == 0
                  ? "0"
                  : "1"
              }
              decimals={detailPriceData.Qty2RoundingPlace}
              value={
                detailPriceData.Qty2
                  ? detailPriceData.Qty2
                  : detailPriceData.Qty2 == 0
                  ? "0"
                  : "1"
              }
              min={
                priceListDetail[0]?.QtyStatisticalUnit
              }
              max={
                priceListDetail[0]?.Stock/detailPriceData?.ConversionRatio
              }
              resetForm={resetForm}
              mode={jobId?'view':mode}
              required={false}
              onChange={(e) => handleQuantityChange(e, "Qty2")}
            />
          </div>
          <div className="col-lg-3">
            <UnitDictionary
              returnObj
              Change={setUserChanges}
              value={detailPriceData.Unit2Id}
              label="Unit2"
              name="Unit2Id"
              required={false}
              mode="view"
              resetForm={resetForm}
              setUnitDictionary={(e) =>
                setDictionaryName((prev) => ({ ...prev, Unit2: e.Value }))
              }
            />
          </div>
          {/* <div className="col-lg-3 col-11">
            <Textbox
              Change={setUserChanges}
              textboxName={
                numberOfSalesUnit === 2 ? "SalesUnitPrice" : "Unit2Price"
              }
              textboxType="text"
              labelText="UnitPrice"
              value={
                detailPriceData[
                  `${numberOfSalesUnit === 2 ? "SalesUnitPrice" : "UnitPrice"}`
                ]
              }

              defaultValue={
                detailPriceData[
                  `${numberOfSalesUnit === 2 ? "SalesUnitPrice" : "UnitPrice"}`
                ]
              }
              resetForm={resetForm}
              mode={priceList.IsManual && mode !== "view" ? "create" : "view"}
              useGroupingPrice={true}
              onChange={(e) => handleUnitPriceChange(e, "Qty2")}
              required={false}
            />
          </div> */}

          {/* <div className="col-lg-3">
            {numberOfSalesUnit === 2 && (
              <Textbox
                Change={setUserChanges}
                textboxName="SubTotalPrice"
                textboxType="text"
                labelText="price"
                value={detailPriceData.SubTotalPrice}

                round={false}
                defaultValue={detailPriceData.SubTotalPrice}
                resetForm={resetForm}
                mode={priceList.IsManual && mode !== "view" ? "create" : "view"}
                useGroupingPrice={true}
                required={false}
              />
            )}
          </div> */}
        </div>
      )}
    </>
  );
};

export default PriceFields;
